module.exports = __webpack_public_path__ + "static/proprioceptive_d-ca429f38420532a688bca48afa8004c7.png";